export default __webpack_public_path__ + "static/media/press_room_thumb_modal1.f568de08.jpg";